import {useSelector} from "react-redux";
import {temporaryTurnSelector} from "../periodValuesFilterApi";
import React from "react";

export default function TemporaryTurnTable() {
    const constructor = useSelector(temporaryTurnSelector);
    const filtersRows = constructor.filtersRows;
    const tableOperations = constructor.tableOperations;

    const createTable = () => {

        return (
            <table border={"1px"} style={{"table-layout": "fixed", "width": "40vw", "border-collapse": "collapse", "margin-bottom": "30px", "font-family": "\"SF UI Text\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\""}}>
                {createHeaders()}
                {createBody()}
                {createTableResultRow()}
            </table>
        );
    }

    const createEmptyColumns = () => {
        return Array.apply(0, Array(filtersRows.length)).map(
            (x,i) => <><td></td></>
        );
    };

    const createHeaders = () => {
        return <>
            <tr>
                <th width={"70px"}>Дата</th>
                <th width={"45px"}>Время</th>{createCodesLine(1)}
            </tr>
        </>
    }

    const createCodesLine = (monthColumnsNumber) => {
        return (
            <>
                {Array.apply(0, Array(monthColumnsNumber)).map(
                    (x,i) => Array.apply(0, Array(filtersRows.length)).map(
                        (x,i) => <th width={60}>{
                            filtersRows[i].code.code == '' ? '' : 'K-' + (i+1)
                        }</th>
                    )
                )}
            </>
        )
    }

    const createBody = () => {
        return (
            <>
                <tr>
                    <td rowSpan={2} align={"center"} >1 января</td>
                    <td width={50} align={"center"}>14.00</td>
                    {createEmptyColumns()}
                </tr>
                <tr>
                    <td align={"center"} >20.00</td>
                    {createEmptyColumns()}
                </tr>

                <tr>
                    <td rowSpan={2} align={"center"}>2 января</td>
                    <td align={"center"}>14.00</td>
                    {createEmptyColumns()}
                </tr>
                <tr>
                    <td align={"center"}>20.00</td>
                    {createEmptyColumns()}
                </tr>

                <tr>
                    <td rowSpan={2} align={"center"}>3 января</td>
                    <td align={"center"}>14.00</td>
                    {createEmptyColumns()}
                </tr>
                <tr>
                    <td align={"center"}>20.00</td>
                    {createEmptyColumns()}
                </tr>

                <tr>
                    <td rowSpan={2} align={"center"}>4 января</td>
                    <td align={"center"}>14.00</td>
                    {createEmptyColumns()}
                </tr>
                <tr>
                    <td align={"center"}>20.00</td>
                    {createEmptyColumns()}
                </tr>

                <tr>
                    <td colSpan={filtersRows.length + 2} align={"center"}>...</td>
                </tr>
            </>
        )
    }

    const createTableResultRow = ()  => {
        return (
            <>
                {
                    Array.apply(0, Array(tableOperations.length)).map((x, i) =>
                        <tr>
                            <td colSpan={2}>{tableOperations[i].name}</td>
                            {createEmptyColumns()}
                        </tr>
                    )
                }
            </>
        )

    }


    return (
        <div>
            {createTable()}
        </div>
    )
}